import React from 'react';
import { Footer } from '../Common/Footer';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../Common/DashboardHeader';
import Request from '../../Models/Request';
import { SideBar } from '../Common/SideBar';
import ProductsUpload from '../../Models/ProductsUpload';
import { Header } from '../Common';
import Pagination from "react-js-pagination";
import {withTranslation} from "react-i18next";
class RequestBulletin extends React.Component {
    constructor(props) {
        super(props);
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state = {
            _id: false,
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: '',
            total: [],
            categories: [],
            subCategories: [],
            category: '',
            sub_cat: '',
            user: '',
            request: [],
            product_name: '',
            category: '',
        };
        this.state.user = logged_user.id;
        this.getCategories();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillMount() {
        Request.getAllpending(1, this.state.user).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }
    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handlePageChange(pageNumber) {
        Request.getAllpending(pageNumber, this.state.user).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload, total: res.data.total, activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }

    pagination() {
        if (this.state.request < 10) {
            return (
                <div></div>
            )
        } else {
            return (
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-6 ml-5">
                        <Pagination
                            hideNavigation
                            activePage={this.state.activePage}
                            itemsCountPerPage={this.state.itemsCountPerPage}
                            totalItemsCount={this.state.total}
                            pageRangeDisplayed={this.state.pageRangeDisplayed}
                            onChange={this.handlePageChange.bind(this)}
                        />
                    </div>
                    <div className="col-md-2"></div>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <SideBar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="">
                                    <div className=" input_name big_font guide_text row" style={{ padding: "2%", width: '100%', border: "none" }}>
                                        <div className="col-md-6">
                                            <span style={{ fontSize: "20px" }}><b>{this.props.t('SELLER_REQUEST_BULLETIN.SELLER_REQUEST_BULLETIN_TITLE')}</b></span>
                                        </div>
                                        <Link to={'/request-home'} className="col-md-6" style={{ textAlign: "left" }}>
                                            <button style={{ borderRadius: "4px", padding: "2%", fontSize: "15px", color: "green", backgroundColor: "white" }}>{this.props.t('SELLER_REQUEST_BULLETIN.BACK_BTN')}</button>
                                        </Link>
                                    </div>
                                    <div className="" style={{ minHeight: "180px" }}>
                                        <div className="card">
                                            <div className="row pages_contents px-3">
                                                {this.state.request.map((group, index) =>
                                                    <div className="" style={{ width: "100%" }} key={index}>
                                                        <div className=" hover_div" style={{ padding: '0px' }}>
                                                            <div className="card-body" style={{ padding: '0.75rem' }}>
                                                                <div className="card-title" style={{ margin: '0px' }}>
                                                                    <Link to={{
                                                                        pathname: `/request-details/${group.id}`,
                                                                        state:
                                                                        {
                                                                            id: group.id,
                                                                            user: this.state.user
                                                                        }
                                                                    }}>
                                                                        <div className="blue_text" style={{ cursor: "pointer" }}>{group.title}</div>
                                                                    </Link>
                                                                </div>

                                                            </div>
                                                            <div className="">
                                                                <div style={{ minHeight: "86px" }}>
                                                                    <div className="col-md-12" >
                                                                        <span style={{ marginRight: '30px' }}>
                                                                            {this.props.t('SELLER_REQUEST_BULLETIN.BUDGET')}
                                                                            </span>
                                                                        <span>
                                                                            {group.budget_range}{this.props.t('SELLER_REQUEST_BULLETIN.YEN')}
                                                                            </span>
                                                                    </div>
                                                                    <div className="col-md-12" >
                                                                        <span style={{ marginRight: '30px' }}>
                                                                            {this.props.t('SELLER_REQUEST_BULLETIN.DEADLINE')}
                                                                            </span>
                                                                        <span>
                                                                            {group.days} {this.props.t('SELLER_REQUEST_BULLETIN.DAYS')}
                                                                            </span></div>
                                                                    <div className="col-md-12">
                                                                        <span style={{ marginRight: '46px' }}>
                                                                            {this.props.t('SELLER_REQUEST_BULLETIN.PROPOSALS')}
                                                                            </span>
                                                                        <span>
                                                                            {group.number_of_proposals} {this.props.t('SELLER_REQUEST_BULLETIN.QUANTITY')}
                                                                            </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.pagination()}
                    </div >
                    <Footer />
                </div >
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="">
                                            <div className=" input_name big_font guide_text row pt-0 pb-0" style={{ padding: "2%", width: '100%', border: "none" }}>
                                                <div className="col-md-6">
                                                    <span style={{ fontSize: "20px" }}><b><i>{this.props.t('SELLER_REQUEST_BULLETIN.SELLER_REQUEST_BULLETIN_TITLE')}</i></b></span>
                                                </div>
                                                <Link to={'/request-home'} className="col-md-6" style={{ textAlign: "right" }}>
                                                    <button style={{ borderRadius: "4px", padding: "2%", fontSize: "15px", color: "green", backgroundColor: "white", height: '30px', width: '20%' }}>{this.props.t('SELLER_REQUEST_BULLETIN.BACK_BTN')}</button>
                                                </Link>
                                            </div>
                                            <div className="mini_padding" style={{ height: "auto", paddingTop: '4px' }}>
                                                <div className="card">
                                                    <div className="row  px-3">
                                                        {this.state.request.map((group, index) =>
                                                            <div className="mini_padding inner-div" style={{ width: "100%" }} key={index}>
                                                                <div className="mini_padding hover_div">
                                                                    <div className="card-body">
                                                                        <div className="card-title">
                                                                            <Link to={{
                                                                                pathname: `/request-details/${group.id}`,
                                                                                state:
                                                                                {
                                                                                    id: group.id,
                                                                                    user: this.state.user
                                                                                }
                                                                            }}>
                                                                                <div className="blue_text" style={{ cursor: "pointer" }}>{group.title}</div>
                                                                            </Link>
                                                                        </div>
                                                                        {/* <div className="card-text">
                                                                            {group.content.substr(0, 20)}...
                                                                        </div> */}
                                                                    </div>
                                                                    <div className="">
                                                                        <div style={{ minHeight: "86px" }}>
                                                                            {/* <div className="row"> */}
                                                                            <div className="col-md-12" >
                                                                                <span style={{ marginRight: '30px' }}>
                                                                                    {this.props.t('SELLER_REQUEST_BULLETIN.BUDGET')}
                                                                            </span>
                                                                                <span>
                                                                                    {group.budget_range}{this.props.t('SELLER_REQUEST_BULLETIN.YEN')}
                                                                            </span>
                                                                            </div>
                                                                            <div className="col-md-12" >
                                                                                <span style={{ marginRight: '30px' }}>
                                                                                    {this.props.t('SELLER_REQUEST_BULLETIN.DEADLINE')}
                                                                            </span>
                                                                                <span>
                                                                                    {group.days} {this.props.t('SELLER_REQUEST_BULLETIN.DAYS')}
                                                                            </span></div>
                                                                            <div className="col-md-12">
                                                                                <span style={{ marginRight: '46px' }}>
                                                                                    {this.props.t('SELLER_REQUEST_BULLETIN.PROPOSALS')}
                                                                            </span>
                                                                                <span>
                                                                                    {group.number_of_proposals} {this.props.t('SELLER_REQUEST_BULLETIN.QUANTITY')}
                                                                            </span>
                                                                            </div>
                                                                        </div>
                                                                        {/* </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.pagination()}
                                {/* <div className="row">
                                <div className="col-md-4"></div>
                                <div className="col-md-6 ml-5">
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.state.itemsCountPerPage}
                                        totalItemsCount={this.state.total}
                                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                                        onChange={this.handlePageChange.bind(this)}
                                    />
                                </div>
                                <div className="col-md-2"></div>
                            </div> */}
                            </div>
                        </div>
                    </div >
                    <Footer />
                </div >
            )
        }
    }
}
export { RequestBulletin }
RequestBulletin = withTranslation('seller')(RequestBulletin);
